import React from "react";
import { Col, Row, Button } from "cakemail-ui-components/lib/react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

export const EmptyListingPage = (props) => {
	function goTo(path) {
		if (props.onBtnClick) {
			props.onBtnClick();
		} else if (props.locationChange) {
			window.location = path;
		} else {
			props.history.push(path);
		}
	}
	return (
		<Row
			middle="xs"
			className={`emptyListContainer ${props.emptySearch ? "emptySearch" : ""}`}
		>
			<Col xs={12} className="content">
				<div className="image">
					{props.textImage && <h2>{props.textImage}</h2>}
					{(props.image || props.emptyImage) && (
						<img src={props.image || props.emptyImage} />
					)}
				</div>
				<div className="text">
					<div className="title lead">{props.title}</div>
					<div className="description">
						<p className="tall">{props.description}</p>
					</div>
					{props.buttonLabel && (
						<div className="button">
							<Button
								colorTheme="teal"
								size="small"
								type="submit"
								onClick={() => goTo(props.path)}
								shapeStyle="fill"
								radius="round"
							>
								{props.buttonLabel}
							</Button>
						</div>
					)}
				</div>
			</Col>
		</Row>
	);
};

EmptyListingPage.propTypes = {
	image: PropTypes.string,
	path: PropTypes.string,
	buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	title: PropTypes.any,
	description: PropTypes.any,
	emptySearch: PropTypes.bool,
	textImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	history: PropTypes.object,
	locationChange: PropTypes.bool,
	onBtnClick: PropTypes.func,
	emptyImage: PropTypes.string,
};

EmptyListingPage.defaultProps = {
	className: "",
	emptySearch: false,
	onBtnClick: null,
};

export default withRouter(
	connect(
		(state) => {
			return {
				emptyImage: state.brand.images["ill-empty-listing"],
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(EmptyListingPage)
);
